import { hasRule, espaceBeneficiaireRules as rules } from "@/utils/rulesHelper"

function buildMenu() {
  let children = []

  // if (hasRule(rules.ACCESS_ESPACE_BENEFICIAIRE)) {
    children.push({ name: 'Accueil', url: '/espace-beneficiaire/accueil', icon: 'icon-home' })
  // }
  if (hasRule(rules.ACCESS_NEWS)) {
    children.push({ name: 'Actualités', url: '/espace-beneficiaire/actualites', icon: 'fa fa-newspaper-o' })
  }
  if (hasRule(rules.ACCESS_BENEFICIAIRES)) {
    children.push({ name: 'Bénéficiaires', url: '/espace-beneficiaire/beneficiaires', icon: 'icon-people' })
  }
  if (hasRule(rules.ACCESS_JUSTIFICATIFS)) {
    children.push({ name: 'Justificatifs', url: '/espace-beneficiaire/justificatifs', icon: 'fa fa-paperclip' })
  }
  if (hasRule(rules.ACCESS_CONTACTS)) {
    children.push({ name: 'Contacts', url: '/espace-beneficiaire/gestion-des-contacts', icon: 'icon-speech' })
  }
  if (hasRule(rules.ACCESS_DECOMPTES)) {
    children.push({ name: 'Décomptes', url: '/espace-beneficiaire/gestion-des-decomptes', icon: 'icon-docs' })
  }
  if (hasRule(rules.ACCESS_INSCRIPTIONS)) {
    children.push({ name: 'Inscriptions', url: '/espace-beneficiaire/inscriptions', icon: 'icon-people' })
  }
  if (hasRule(rules.ACCESS_ECHEANCIER)) {
    children.push({ name: 'Echéancier', url: '/espace-beneficiaire/echeancier', icon: 'icon-calendar' })
  }
  if (hasRule(rules.ACCESS_STATS)) {
    children.push({ name: 'Statistiques', url: '/espace-beneficiaire/statistiques', icon: 'icon-chart' })
  }
  if (hasRule(rules.ACCESS_CONFIG_SUJETS)) {
    children.push({name: 'Paramétrage Sujets', url: '/espace-beneficiaire/gestion-des-sujets', icon: 'icon-wrench'})
  }
  if (hasRule(rules.ACCESS_FAQ)) {
    children.push({name: 'Paramétrage FAQ', url: '/espace-beneficiaire/gestion-des-faq', icon: 'icon-wrench'})
  }

  return children
}
let menu = {
  items: buildMenu()
}
export default menu